export default {
    'searchList': {
        'searchTxt': [{
            'name': '发车单号',
            'value': 'ettgEtdoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '是否关闭',
            'value': 'ettgFollowStatus',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SYS_YES_NO',
            'multiple': false
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 30,
            'unfold': true,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '发车单号',
                'prop': 'ettgEtdoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '异常分类',
                'prop': 'ettgAbnormalClassType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '异常类型',
                'prop': 'ettgAbnormalTypeName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '登记人',
                'prop': 'ettgRegistrant',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '登记时间',
                'prop': 'ettgRegistrantDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否关闭',
                'prop': 'ettgFollowStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '跟进人',
                'prop': 'ettgFollow',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '跟进人电话',
                'prop': 'ettgFollowMobile',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '跟进内容',
                'prop': 'ettgFollowRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '备注',
                'prop': 'ettgRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '修改人',
                'prop': 'modifier',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '修改时间',
                'prop': 'modifyTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit',
                'ifHas': '05040201'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    }
};
